import React from "react";
import { useNavigate } from "react-router-dom";
import "./FamilyPlanningEntryCard.css";

const FamilyPlanningEntryCard = ({ user1Id, user2Id, partnerName }) => {
  const navigate = useNavigate();

  const handleOpen = () => {
    navigate(`/family-planning/${user1Id}/${user2Id}`);
  };

  return (
    <div className="family-planning-entry-card">
      <div className="family-planning-entry-text">
        <h4>Family planning genetics available</h4>
        <p>
          {partnerName ? `You and ${partnerName}` : "This couple"} can now access
          optional clinical carrier screening. This is a separate service — it
          never affects your compatibility score or matches.
        </p>
      </div>
      <button className="family-planning-entry-btn" onClick={handleOpen}>
        Start family planning genetics
      </button>
    </div>
  );
};

export default FamilyPlanningEntryCard;